/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-social-share.html";
import { SocialMediaShare } from "@nuskin/ns-util";

/**
 * The ns-social-share should be used for
 *
 * <h1>Social Share</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-social-share></ns-social-share>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsSocialShare extends PolymerElement {
  static get is() {
    return "ns-social-share";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  constructor() {
    super();

    let x = window.matchMedia("(min-width: 768px)");

    if (x.matches) {
      this.pinterestImageUrl = "";
    } else {
      this.pinterestImageUrl = $("meta[property='og:image']").attr("content")
        ? $("meta[property='og:image']").attr("content")
        : "";
    }
  }

  ready() {
    super.ready();
    if (this.color) {
      this.colorString = "nuskin-color";
    }
  }

  static get properties() {
    return {
      share: {
        type: String,
        value: "share"
      },
      noFacebook: {
        type: Boolean,
        value: false,
        observer: "_facebookChanged"
      },
      noTwitter: {
        type: Boolean,
        value: false,
        observer: "_twitterChanged"
      },
      noPinterest: {
        type: Boolean,
        value: false,
        observer: "_pinterestChanged"
      },
      noEmail: {
        type: Boolean,
        value: false,
        observer: "_emailChanged"
      },
      showName: {
        type: Boolean,
        value: true
      },
      color: {
        type: Boolean,
        value: false
      },
      colorString: {
        type: String,
        value: "nuskin"
      },
      displayType: {
        type: String,
        value: "link"
      },
      urlToShare: {
        type: String,
        value: window.location.href
      },
      pinterestImageUrl: {
        type: String,
        value: ""
      }
    };
  }

  shareProfile(e) {
    let shareURL = SocialMediaShare.getShareHREF(
      this.urlToShare,
      e.currentTarget.id,
      "",
      this.pinterestImageUrl
    );
    window.open(shareURL, "_blank");
  }

  _facebookChanged(newValue, oldValue) {
    if (newValue) {
      this.$.facebook.style.display = "none";
    } else {
      this.$.facebook.style.display = "block";
    }
  }

  _twitterChanged(newValue, oldValue) {
    if (newValue) {
      this.$.twitter.style.display = "none";
    } else {
      this.$.twitter.style.display = "block";
    }
  }

  _pinterestChanged(newValue, oldValue) {
    if (newValue) {
      this.$.pinterest.style.display = "none";
    } else {
      this.$.pinterest.style.display = "block";
    }
  }

  _emailChanged(newValue, oldValue) {
    if (newValue) {
      this.$.email.style.display = "none";
    } else {
      this.$.email.style.display = "block";
    }
  }
}

customElements.define(NsSocialShare.is, NsSocialShare);
